import { motion } from 'framer-motion';

export const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer data-testid="footer" className="py-6 md:py-8 px-6 md:px-12 lg:px-24 border-t border-black/10 dark:border-white/5 bg-white dark:bg-black">
      <div className="max-w-screen-2xl mx-auto">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          {/* Left coordinates */}
          <div className="flex items-center gap-4 font-mono text-[10px] text-white/15">
            <span>0000</span>
            <span>X</span>
            <span>1920</span>
            <span>W</span>
            <span className="text-white/5">|</span>
            <span>0540</span>
          </div>

          {/* Center - Copyright & Back to top */}
          <button
            data-testid="back-to-top"
            onClick={scrollToTop}
            className="font-mono text-[10px] text-black/50 dark:text-white/30 hover:text-black/80 dark:text-white/60 transition-colors"
          >
            © 2026 KNOXOPIA
          </button>

          {/* Right coordinates */}
          <div className="flex items-center gap-4 font-mono text-[10px] text-white/15">
            <span>0000</span>
            <span>Y</span>
            <span>1080</span>
            <span>H</span>
            <span className="text-white/5">|</span>
            <span>0960</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
